import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { downloadFile, getLongDate, getStringDate } from 'src/app/common/util';
import { AccountReceivableReportResponse, ClientAccountReceivableResponse, VendorAccountResponse } from 'src/app/models/account-receivable.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { AccountPayableReportService } from 'src/app/services/reports/account-payable-report.service';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { VendorService } from 'src/app/services/vendor.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-account-payable-report',
  templateUrl: './account-payable-report.component.html',
  styleUrls: ['./account-payable-report.component.scss']
})
export class AccountPayableReportComponent {
  selectedReport = 0;
  endDate = "";
  startDate = "";
  warehouses: WarehouseResponse[] = [];
  warehouse = 0;
  accountsReport1 = [];
  paginationAccountsReport1 = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  accountsReport2 = [];
  paginationAccountsReport2 = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }

  client = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  clients = [];
  filterClients = [];
  clientSelected = null;
  timeout = null;
  filterWordReport1: string = "";
  filterWordReport2: string = "";

  constructor(
    private accService: AccountPayableReportService,
    private toastService: ToastrService,
    private warehouseService: WarehouseService,
    private accountingReport: AccountingReportService,
    private vendorService: VendorService
  ) {

    const today = new Date();
    this.endDate = getStringDate(today);
    today.setDate(today.getDate() - 30);
    this.startDate = getStringDate(today);
    this.getWarehouses();
    this.getInitVendors();
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data as WarehouseResponse[];
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener las bodegas");
      }
    })
  }

  getStatementReportGeneral(type:string){
    this.accountingReport.getStatementReport(getLongDate(this.startDate), getLongDate(this.endDate), type, "cxp").subscribe({
      next:(response:ResponseObject)=>{
        downloadFile(response.data,type,'Estado de cuenta CxP General');
        this.toastService.success("Se ha descargado el reporte de Estado de cuenta CxP General");
      },
      error: (error:any) =>{
        this.toastService.error("Error al obtener el reporte de Estado de cuenta CxP General");
      }
    })
  }

  getStatementReportFilter(type:string){
    if(this.clientSelected == null){
      this.toastService.error("Error debe seleccionara el proveedor antes de realizar el reporte");
      return;
    }
    this.accountingReport.getStatementReportByVendor(getLongDate(this.startDate), getLongDate(this.endDate), type, this.clientSelected.id, "cxp").subscribe({
      next:(response:ResponseObject)=>{
        downloadFile(response.data,type,'Estado de cuenta CxP Por Proveedor');
        this.toastService.success("Se ha descargado el reporte de Estado de cuenta CxP Por Proveedor");
      },
      error: (error:any) =>{
        this.toastService.error("Error al obtener el reporte de Estado de cuenta CxP Por Proveedor");
      }
    })
  }

  getInitVendors(){
    this.vendorService.getProvidesByClue("").subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data;
        this.clients = clientsData;
        this.client.filterElements = clientsData;
        this.client.class = "fa-list";
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    }); 
  }

  selectClient(client: any, status: number) {
      this.client.value = `${client.name} - ${client.nit}`;
      this.client.class = "fa-check";
      this.client.required = false;
      this.filterClients = this.clients;
      this.clientSelected = client;
    }
  
  writeClient() {
    clearTimeout(this.timeout);
    this.client.class = "typing";

    const clue = (this.client.value ?? "").trim();

    this.timeout = setTimeout(() => {
      this.client.class = "loading";

      this.vendorService.getProvidesByClue(clue).subscribe({
        next: (resp: ResponseObject) => {
          // Asegura arreglo
          const rawList = Array.isArray(resp.data) ? resp.data : [];

          // Por si el backend trae mixto, nos quedamos solo con los que son proveedores
          //const providers = rawList.filter((p: any) => p?.provider === true || p?.inventarios === true);
          const providers = rawList;

          this.client.filterElements = providers;

          if (providers.length === 0) {
            this.client.class = "fa-xmark";
            this.client.required = true;
          } else {
            this.client.class = "fa-filter";
            this.client.required = false;
          }
        },
        error: (_err: any) => {
          this.client.required = true;
          this.client.class = "fa-xmark";
          this.toastService.error(`Error al obtener los proveedores "${clue}".`);
        }
      });
    }, 500);
  }

  getBillReceivableGeneralBalanceReport(type: string) {
    this.accService.getBillPayableGeneralBalanceReport(getLongDate(this.endDate), type, this.warehouse).subscribe({
      next: (response: ResponseObject) => {
        if (type == 'json') {
          var accounts = response.data;
          this.accountsReport1 = accounts.vendorList;
          this.searchingReport1();
        } else {
          downloadFile(response.data, type, 'Reporte de Antigüedad de Saldos');
          this.toastService.success("Se ha descargado el reporte de Antigüedad de Saldos");
        }
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener el reporte de Antigüedad de Saldos");
      }
    })
  }

  onInputChangeReport1(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWordReport1 = value;
    this.searchingReport1();
  }

  searchingReport1() {
    this.paginationAccountsReport1.total = this.accountsReport1.filter((item) => {
      const filter = this.filterWordReport1.toLowerCase();

      return (
        item.code.toLowerCase().includes(filter) ||  item.name.toLowerCase().includes(filter) ||
        item.balance.toString().toLowerCase().includes(filter)
      );
    });

    this.paginationAccountsReport1.pageIndex = 0;
    this.paginationAccountsReport1.startElement = 0;
    this.paginationAccountsReport1.filter = this.paginationAccountsReport1.total.slice(0, this.paginationAccountsReport1.pageSize);
    this.paginationAccountsReport1.lastElement = this.paginationAccountsReport1.filter.length;
  }

  getBillPayableList(type: string) {
    this.accService.getBillPayableList(type).subscribe({
      next: (response: ResponseObject) => {
        if (type == 'json') {
          var accounts = response.data;
          this.accountsReport2 = accounts;
          this.searchingReport2();
        } else {
          downloadFile(response.data, type, 'Reporte de Control de Saldos por Clientes');
          this.toastService.success("Se ha descargado el reporte de Control de Saldos por Clientes");
        }
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener el reporte de Control de Saldos por Clientes");
      }
    })
  }

  onInputChangeReport2(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWordReport2 = value;
    this.searchingReport2();
  }

  searchingReport2() {
    this.paginationAccountsReport2.total = this.accountsReport2.filter((item) => {
      const filter = this.filterWordReport2.toLowerCase();

      return (
        item.code.toLowerCase().includes(filter) ||  item.name.toLowerCase().includes(filter) ||
        item.nit.toLowerCase().includes(filter) || item.balance.toString().toLowerCase().includes(filter)
      );
    });

    this.paginationAccountsReport2.pageIndex = 0;
    this.paginationAccountsReport2.startElement = 0;
    this.paginationAccountsReport2.filter = this.paginationAccountsReport2.total.slice(0, this.paginationAccountsReport2.pageSize);
    this.paginationAccountsReport2.lastElement = this.paginationAccountsReport2.filter.length;
  }
}
